export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15006.e27a8218.jpg";